// src/features/editor/hooks/useIsCourseAuthor.ts
import { useMe } from '@/features/auth/useMe'
import { useAppSelector } from '@/store/hooks'
import type { Course, CourseWithoutBlocks } from '@/types/course'

type CourseLike = Pick<Course | CourseWithoutBlocks, 'authors'>

export const useIsCourseAuthor = (course: CourseLike | null | undefined): boolean => {
  const { data: me } = useMe()
  const forceIsAdmin = useAppSelector((s) => s.dev.forceIsAdmin)

  if (!me || !course) return false
  if (me.isAdmin) return true
  if (import.meta.env.DEV && forceIsAdmin) return true
  return course.authors.some((a) => a.id === me.id)
}
